<template>
  <v-dialog v-model="dialogVisible" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Exportar Solicitudes de Pago</span>
      </v-card-title>

      <v-card-text>
      
          <v-row>
            <v-col cols="12">
              <p class="subtitle-1 mb-4">Seleccione el formato de exportación:</p>
              
              <v-radio-group v-model="exportType" mandatory>
                <v-radio 
                  label="Listado estándar (Excel)" 
                  value="standard"
                  class="mb-2"
                ></v-radio>
                <v-radio 
                  label="Formato para transferencias bancarias" 
                  value="bank_transfer"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" v-if="exportType === 'bank_transfer'">
              <v-alert
                type="info"
                dense
                outlined
                class="mb-3"
              >
                En el formato bancario se exportan únicamente órdenes de pago aprobadas con forma de pago transferencia o débito.
              </v-alert>

              <v-combobox
                v-model="selectedBank"
                :items="banks"
                item-text="name"
                item-value="code"
                label="Seleccione el banco *"
                outlined
                dense
                :loading="loading_banks"
                :rules="[v => exportType !== 'bank_transfer' || !!v || 'Debe seleccionar un banco']"
              ></v-combobox>
              
              <v-alert
                v-if="selectedBank && selectedBank.code !== 15"
                type="warning"
                dense
                outlined
                class="mt-2"
              >
                <strong>Formato no disponible</strong>
                <br>
                Por el momento no contamos con el formato de transferencia para {{ selectedBank.clean_name }}. 
                Por favor, contacte al administrador del sistema.
              </v-alert>
            </v-col>
          </v-row>
   
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close">
          Cancelar
        </v-btn>
        <v-btn 
          color="success" 
          :disabled="!canExport"
          @click="confirmExport"
          text
        
        >
          Exportar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import Constant from "@/constants/sections";
import { paymentOrderService } from "../../libs/ws/paymentOrderService";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      exportType: 'standard',
      selectedBank: null,
      banks: [],
      loading_banks: false
    };
  },
  mounted() {
    this.loadBanks();
  },
  computed: {
    dialogVisible: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      }
    },
    canExport() {
      if (this.exportType === 'standard') {
        return true;
      }
      // Para formato bancario, debe tener banco seleccionado y debe ser ICBC (code BANK_ICBC_CODE)
      return this.selectedBank && this.selectedBank.code === paymentOrderService.BANK_ICBC_CODE;
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
    exportType(newVal) {
      // Si cambia a standard, limpiar banco seleccionado
      if (newVal === 'standard') {
        this.selectedBank = null;
      }
    }
  },
  methods: {
    loadBanks() {
      this.loading_banks = true;
      generalService.setSection(Constant.SECTION_BANKS);
      generalService
        .query({}, Constant.SECTION_BANKS + "/list_from_accounts")
        .then((response) => {
          this.banks = response.result;
          this.loading_banks = false;
        })
        .catch((e) => {
          console.log("Error cargando bancos", e);
          this.loading_banks = false;
        });
    },
    close() {
      this.$emit('closeDialog');
    },
    resetForm() {
      this.exportType = 'standard';
      this.selectedBank = null;
    },
    confirmExport() {
      const exportConfig = {
        type: this.exportType,
        bank: this.exportType === 'bank_transfer' ? this.selectedBank : null
      };
      this.$emit('export', exportConfig);
      this.close();
    }
  }
};
</script>

<style scoped>
</style>
